import { FC } from "react";
import { Column } from "../../../containers";
import { ActivityBodyProps } from "./types";
import { AlignItems, JustifyContent } from "../../../containers/types";

const ActivityBody: FC<ActivityBodyProps> = ({
  children,
  props,
  className = "",
  style = {},
}) => {
  return (
    <Column
      alignItems={AlignItems.Start}
      justifyContent={JustifyContent.Start}
      className={className}
      style={{ width: "80%", ...style }}
      gap={10}
      props={props}
    >
      {children}
    </Column>
  );
};

export default ActivityBody;
